module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens24-5decc2a708c9c211f0e7b3ec9f84d87d.jpg";